export default function Splash() {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: '100vh' }}
      role="status"
    >
      <div className="spinner-border text-primary" aria-hidden="true" />
      <span className="visually-hidden">Loading…</span>
    </div>
  );
}
